/* ============================================================
   DAVIE LAKE VIEW — Bloque de tasa, pago mensual y poder de compra

   El precio sale del catálogo que publica `davie-modelos`: se usa el más bajo
   de los modelos disponibles, que es el mismo "desde" que ve la persona en el
   explorador. Los pagos se calculan con la fórmula de amortización estándar
   más un estimado mensual de impuestos, seguro y HOA.

   Nada de esto está escrito a mano: si Andrew cambia un precio o una tasa, la
   pieza entera se recalcula.
   ============================================================ */
(function () {
  'use strict';

  var sec = document.getElementById('davie-tasa');
  if (!sec) return;

  function num(attr, porDefecto) {
    var v = parseFloat(sec.getAttribute(attr));
    return isNaN(v) ? porDefecto : v;
  }

  var TASA_MERCADO = num('data-tasa-mercado', 7.125);
  var TASA_CONST = num('data-tasa-constructora', 5.5);
  var INICIAL_PCT = num('data-inicial-pct', 5);
  var PLAZO = num('data-plazo', 30);
  var OTROS = num('data-otros', 1471);
  var FALLBACK = num('data-precio-fallback', 732490);

  /* ---- Precio: el más bajo del catálogo ---- */
  function precioDesde() {
    try {
      var el = document.getElementById('davie-catalogo');
      if (!el) return FALLBACK;
      var arr = JSON.parse(el.textContent || '[]');
      if (!Array.isArray(arr)) return FALLBACK;
      var precios = arr
        .filter(function (m) { return m.available && m.price > 0; })
        .map(function (m) { return m.price; });
      if (!precios.length) return FALLBACK;
      return Math.min.apply(null, precios);
    } catch (e) { return FALLBACK; }
  }

  /* ---- Cuota mensual de capital e interés ---- */
  function cuota(capital, tasaAnual, anios) {
    var r = tasaAnual / 100 / 12;
    var n = anios * 12;
    if (r <= 0) return capital / n;
    return capital * r / (1 - Math.pow(1 + r, -n));
  }

  /* ---- Cuánta casa alcanza un pago mensual dado, a una tasa dada ----
     Los impuestos y el seguro suben con el precio, así que el estimado de
     costos mensuales se toma como proporción del precio y no como un monto
     fijo. Si no, el poder de compra sale inflado.
     ---------------------------------------------------------------- */
  function precioQueAlcanza(pagoTotal, tasaAnual, anios, ratioOtros) {
    var r = tasaAnual / 100 / 12;
    var n = anios * 12;
    var financiado = 1 - INICIAL_PCT / 100;
    var factorCuota = r <= 0 ? 1 / n : r / (1 - Math.pow(1 + r, -n));
    var porDolarDePrecio = financiado * factorCuota + ratioOtros;
    if (porDolarDePrecio <= 0) return 0;
    return pagoTotal / porDolarDePrecio;
  }

  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  /* Una tasa se muestra tal cual la escribió Andrew, hasta tres decimales.
     Redondeando a dos, 7.125% salía "7.13%" — un número que él no dijo, en
     una página donde las tasas las firma una licencia de Florida. */
  function pct(n) {
    var r = Math.round(n * 1000) / 1000;
    return (r % 1 === 0 ? r.toFixed(0) : String(r)) + '%';
  }

  /* Los puntos de ventaja se redondean HACIA ABAJO, a un decimal.
     7.125 − 5.5 = 1.625, y "1.63 puntos menos" se agranda la ventaja en una
     cifra que el comprador puede comprobar con una calculadora. Se dice 1.6. */
  function puntos(n) { return String(Math.floor(n * 10) / 10); }
  function set(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }

  function pintar() {
    var precio = precioDesde();
    var capital = precio * (1 - INICIAL_PCT / 100);
    var inicial = precio * (INICIAL_PCT / 100);

    // Se calculan POR SEPARADO el capital e interes y el pago completo.
    // Los creativos de Meta anuncian solo P&I ($4,899 vs $3,978) y la pagina
    // mostraba solo el total ($6,378 vs $5,457): el que llegaba del anuncio
    // veia $1,479 mas y sentia que la pagina era mas cara. Es la regla de
    // match. Ahora se ven las dos, con la del anuncio arriba.
    var piMercado = cuota(capital, TASA_MERCADO, PLAZO);
    var piConst = cuota(capital, TASA_CONST, PLAZO);
    var pagoMercado = piMercado + OTROS;
    var pagoConst = piConst + OTROS;
    // El ahorro es el MISMO con P&I o con el total —los otros costos no
    // cambian entre las dos columnas— y es la cifra que tambien anuncian
    // los creativos. No se toca.
    var ahorroMes = pagoMercado - pagoConst;

    var ratioOtros = precio > 0 ? OTROS / precio : 0;
    var alcanza = precioQueAlcanza(pagoMercado, TASA_CONST, PLAZO, ratioOtros);
    var extra = Math.max(0, alcanza - precio);

    set('davie-tasa-precio', money(precio));
    // El supuesto del calculo, arriba de las dos cifras. Si cambia el inicial,
    // el plazo o el precio, esta linea se mueve sola.
    set('davie-tasa-sup-pct', pct(INICIAL_PCT));
    set('davie-tasa-sup-ini', money(inicial));
    set('davie-tasa-sup-plazo', String(PLAZO));
    set('davie-tasa-desde', money(precio));
    set('davie-tasa-inicial', money(inicial));
    set('davie-tasa-pct', pct(INICIAL_PCT));

    set('davie-tasa-mercado-lbl', pct(TASA_MERCADO));
    set('davie-tasa-mercado-tasa', pct(TASA_MERCADO));
    set('davie-tasa-const-tasa', pct(TASA_CONST));
    set('davie-tasa-puntos', puntos(TASA_MERCADO - TASA_CONST));

    set('davie-tasa-mercado-pago', money(piMercado));
    set('davie-tasa-const-pago', money(piConst));
    set('davie-tasa-mercado-total', money(pagoMercado));
    set('davie-tasa-const-total', money(pagoConst));

    set('davie-tasa-ahorro-mes', money(ahorroMes));
    set('davie-tasa-ahorro-anio', money(ahorroMes * 12));
    set('davie-tasa-bene-ahorro', money(ahorroMes));
    set('davie-tasa-poder', money(extra));
  }

  pintar();

  // El editor de temas vuelve a dibujar la sección de modelos cuando Andrew
  // cambia un precio: hay que recalcular o la pieza queda con el número viejo.
  document.addEventListener('shopify:section:load', pintar);
})();
